<template>
    <transition class="font-poppins" name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal w-1/3 md:w-full rounded-lg"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header text-center"
          id="modalTitle"
        >
          <slot name="header">
              <p>Confirm</p>
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            x
          </button>
        </header>

        <section
          class="modal-body text-center "
          id="modalDescription"
        >
          <slot name="body">
            
            <p>Are you sure you want to logout?</p>
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            
          </slot>
          <div class="flex justify-around">
              <button
                type="button"
                class="bg-blue-700 border p-2 text-white rounded-lg w-1/2"
                @click="logout"
                aria-label="Close modal"
            >
                YES
                <i v-if="isLoading" class="fa fa-spinner fa-spin text-white"></i>
            </button>
            
            <button
                type="button"
                class="bg-blue-700 text-white border p-2 rounded-lg w-1/2"
                @click="noLogout"
                aria-label="Close modal"
            >
                NO
            </button>
          </div>
          
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    mounted() {
        this.networkError();
    },
    data(){
      return{
        isLoading:false
      }
    },
    methods : {
        close() {
            this.$emit('close');
        },
        logout() {
           let token = localStorage.getItem("refereshToken")
          let id = localStorage.getItem("userId")
          localStorage.removeItem("ipAddress");
          this.isLoading = true;
        axios({
          method: 'post',
          url: `${url}/v1/web/auth/logout`,
          headers: {
              'Content-type': 'application/json',
              'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
          },
          data: {
              refreshToken: token,
              userId : id,
          }
          })
          .then((res) => {
            res
            this.isLoading = false;
            localStorage.removeItem('ipAddress')
             localStorage.removeItem('user')
             localStorage.removeItem('refereshToken')
             localStorage.removeItem('userEmail')
             localStorage.removeItem('userType')
             localStorage.removeItem('token')
             localStorage.removeItem('userId')
            this.$router.push("/admin/login");
          })
          .catch((err) => err)
        },

        noLogout() {
            this.$router.go(-1)
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>

<section class="font-poppins">
        <div class=" w-1/3 m-auto bg-gray-200 rounded-2xl mt-36">
            <div class=" border pt-10 pb-10">
                <p class="font-bold text-center">Confirm</p>
                <p class="text-center mt-3">Are you sure you want to logout?</p>
                
                <div class="flex justify-center mt-10">
                    <button class="bg-blue-600 w-1/3 p-2 rounded-xl text-white" @click="noLogout">No</button>
                    <button class=" w-1/3 bg-gray-50 rounded-xl p-2 hover:bg-blue-600 ml-4" @click="logout">Yes</button>
                </div>
            </div>
        </div>
    </section>